import React from 'react';
import { useTypedTranslation } from '@app/hooks';

import { apiExplorerService } from '@app/services';
import { TranslationNamespace } from '@app/models';

interface IProps {
    entity: any;
    schema: any[];
    isBase?: boolean;
}

export const ApiPropertyList = (props: IProps) => {
    const { translation } = useTypedTranslation(TranslationNamespace.apiDescription);
    const { isBase, entity, schema } = props;

    const propertyDescription = (item: any, entity: any) => {
        let split = entity.name.split('.');
        let name = split[split.length - 1];
        name = 'API_' + entity.type + '_' + name + '_' + item.Name;
        name = name.toUpperCase();
        const translatedName = translation(name);
        if (translatedName === name) return item.Name;
        return translatedName;
    };

    const baseType = (item: any) => {
        if (!item || !item.baseType) {
            return null;
        }
        const baseType = schema.find(element => element.name === item.baseType);
        return baseType;
    };

    return (
        <>
            {entity !== undefined && entity !== null && entity.properties.length > 0 &&
                <>
                    <h4 className='apiExplorer__tableSpacing'><span hidden={!isBase}>Inherited</span> Properties <code hidden={!isBase}>({entity.name})</code></h4>

                    <table>
                        <thead>
                            <tr>
                                <td>{translation('METHOD_NAME')}</td>
                                <td>{translation('MEMBER_DATATYPE')}</td>
                                <td>{translation('MEMBER_DESCRIPTION')}</td>
                            </tr>
                        </thead>
                        <tbody>
                            {apiExplorerService.asArray(entity.properties).map((item: any) => (
                                <tr key={item.Name}>
                                    <td>{item.Name}</td>
                                    <td><code>{item.Type}</code></td>
                                    <td>{propertyDescription(item, entity)}</td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>

                    <ApiPropertyList isBase={true} schema={schema} entity={baseType(entity)} />
                </>
            }
        </>
    );
};
